<template>
  <div>
    <div class="bg-container-blue">
      <v-carousel :height="400" hide-controls>
        <v-carousel-item
          v-for="(newsItem, index) in important_posts"
          :key="index"
        >
          <div class="carousel-item-content">
            <img
              src="https://assets-intranet-security.s3.us-east-2.amazonaws.com/fnd-cuadrille-azul+BICE+1.jpg"
              height="400"
              alt="Background Image"
              class="header-image"
            />
            <v-layout class="carousel-overlay w-100">
              <v-flex xs12 md6 lg6 class="order-last order-md-first text-content">
                <div class="overlay-content">
                  <div class="overlay-text">
                    <p class="white--text title-text">
                      <b>{{ newsItem.title }}</b>
                    </p>
                    <button class="btn-outlined-white" @click="goToShowPost(newsItem)">Conoce más</button>
                  </div>
                </div>
              </v-flex>
              <v-flex xs12 md6 lg6 class="order-first order-md-last content-post-image">
                <img
                  :src="newsItem.main_image"
                  alt="Main Image"
                  height="400"
                  class="post-image"
                  @click="goToShowPost(newsItem)"
                />
              </v-flex>
            </v-layout>
          </div>
        </v-carousel-item>
      </v-carousel>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  methods: {
    ...mapActions("posts", ["fetchImportantPosts"]),

    goToShowPost(post) {
      this.$router
        .push({
          name: "post-show",
          params: { slug: post.slug },
        })
        .catch((e) => {});
    },
  },
  computed: {
    ...mapState("posts", ["important_posts"]),
  },
  beforeMount() {
    if (!this.important_posts.length) {
      let view_as = localStorage.getItem("view_as");
      this.fetchImportantPosts(view_as);
    }
  },
};
</script>

<style scoped>
.v-carousel__controls__item div {
  display: none;
}
div.v-carousel__controls > div > button {
  background-color: #919199;
  height: 8px;
  width: 8px;
  border-radius: 50%;
}
div.v-carousel__controls > div > button.v-btn--active {
  width: 40px;
  height: 8px;
  border-radius: 20px;
  background-color: #fff !important;
}
.v-carousel__controls {
  bottom: 3rem;
}

.bg-container-blue {
  width: 100%;
  height: 400px;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}

.header-image {
  width: 100% !important;
  height: 100%;
  object-fit: cover;
  object-position: center;
}

.carousel-overlay {
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 100%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.post-image {
  flex: 1;
  object-fit: cover;
  cursor: pointer;
  width: 100%;
  background-size: cover;
}
.content-post-image{
  width: 100%;
  height: 100%;
  z-index: 3;
}

</style>